import React, { createRef, Fragment, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Button, Col, Row } from "reactstrap";
import APIPortalTable from "../common/Table/APIPortalTable";

const MasterCustomerHistoryModal = ({ masterCustomerHistory }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, [masterCustomerHistory]);

  const columns = [
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "master_customer_id",
      header: "Master Customer ID",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "updatedby",
      header: "Updated By",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "updatedon",
      header: "Updated on",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "old_status",
      header: "Old Status",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "new_status",
      header: "New Status",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "comment",
      header: "Comment",
    },
  ];

  return (
    <div>
      <Fragment>
        <APIPortalTable
          data={masterCustomerHistory}
          columns={columns}
          loading={isLoading}
          enablePagination
          CSVFileName={"master customer history details.csv"}
        />
      </Fragment>
    </div>
  );
};

export default MasterCustomerHistoryModal;
